/* tslint:disable */
import React from 'react';
import Head from 'next/head';

interface ITermly {
  id: string;
}

const Termly: React.FunctionComponent<ITermly> = ({ id }) => {
  const props = {
    className: 'Termly__wrapper',
    name: 'termly-embed',
    ['data-id']: id,
    ['data-type']: 'iframe',
  };

  return (
    <>
      <div {...props} />
      <Head>
        <script
          id="termly-jssdk"
          key="termly-jssdk"
          src="https://app.termly.io/embed-policy.min.js"
        />
      </Head>
    </>
  );
};

export default Termly;
